// extracted by mini-css-extract-plugin
module.exports =  {"promo-header":"a10a3f92e9--promo-header--qOxtr","promo-info":"a10a3f92e9--promo-info--R7zEy","author-logo":"a10a3f92e9--author-logo--hUKnz"};